import { fromLonLat } from 'ol/src/proj';
import React, { useState, useEffect, useContext, useRef } from 'react';
import { getCoordOfPoint } from 'shared';

import Context from '../components/context';
import { createMarker } from '../utils';
import {
	renderRoutePointHoverTooltip,
	renderRoutePointSelectedTooltip,
} from '../components/MapMarkers/TooltipRenderer';

const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

let lastSelectedMarker = null;

export default function useDrawPointMarkers() {
	const { map, setPointMarkers, removePoint } = useContext(Context);
	const [points, setPoints] = useState();
	const markers = useRef([]);

	useEffect(() => {
		if (points && map) {
			const newMarkers = points.map((point, i) => {
				const coord = getCoordOfPoint(point);
				const lonLat = fromLonLat([coord[1], coord[0]]);
				const title =
					point.shownLabel || point.name || point.disassembledName || point.desc;

				const marker = createMarker(point, {
					type: 'routepoint',
					label: ALPHABET.charAt(i),
					state: 3,
					onHover: () => {
						// Only show hover tooltip if not selected
						if (!marker.get('selected')) {
							renderRoutePointHoverTooltip(point, marker, map, title);
						}
					},
					onClick: () => {
						// Clear previous selection
						if (lastSelectedMarker !== null && lastSelectedMarker !== marker) {
							lastSelectedMarker.set('selected', false);
							lastSelectedMarker.changed();
						}

						// Mark as selected and show selected tooltip with button
						marker.set('selected', true);
						marker.changed();
						lastSelectedMarker = marker;

						renderRoutePointSelectedTooltip(point, marker, map, title, removePoint);
					},
				});

				return marker;
			});

			setPointMarkers(newMarkers);

			markers.current = newMarkers;
		}
		return () => {
			if (!map) return;
			setPointMarkers([]);
		};
	}, [map, points, setPointMarkers, removePoint]);

	return setPoints;
}
